import coverPhoto from '../assets/hotspot/celebrationCover/Passover.jpg';
import lilyImage from '../assets/hotspot/headerImages/lily-s.jpg';
import celebrationThumbnail1 from '../assets/hotspot/celebrationPerformances/Pesah_a_la_Mano_learn.jpg';
import celebrationThumbnail2 from '../assets/hotspot/celebrationPerformances/Lily_learn_concert.jpg.jpeg';

export const passover = {
  celebrationTitle: 'Passover',
  startDate: '04-01',
  endDate: '04-09',
  filterValue: 'passover',
  displayDate: 'Dates Vary Each Year',
  celebrationImage: coverPhoto,
  description: 'Passover is a Jewish holiday celebrating the ancient Jewish exodus from slavery. The holiday lasts 7 or 8 days, and Jews traditionally refrain from eating leavened bread during this time. Jewish families come together on the first and second nights of Passover with a ritual dinner called a seder.',
  celebrationVideos: [
    {
      videoLink: 'https://vimeo.com/1105190726?fl=pl&fe=sh',
      videoImage: celebrationThumbnail1,
      songTitle: 'Pesah a la Mano',
      artistName: 'Lily',
      videoTags: [
        {
          tag: 'Purim',
        },
        {
          tag: 'Passover',
        },
      ],
      songDescription: '"Pesah a la Mano" ("Passover Is at Hand") is a Ladino song that celebrates the joyful transition from Purim to Passover. The lyrics express the love that goes into preparing for holidays, like cleaning the house and cooking traditional food to share. This song is one of many Ladino songs that connects generations through music.',
    },
    {
      videoLink: 'https://vimeo.com/1105192269?fl=pl&fe=vl',
      videoImage: celebrationThumbnail2,
      songTitle: 'Pesah a la Mano',
      artistName: 'Lily',
      videoTags: [
        {
          tag: 'Purim',
        },
        {
          tag: 'Passover',
        },
      ],
    },
  ],
  artistsWhoCelebrate: [
    {
      artistName: 'Lily',
      artistImage: lilyImage,
    },
  ],
};
